<template>
  <FileViewContainer>
    <template #default="{viewFile}">
      <div class="d-flex flex-column justify-center ma-0 pa-0">
        <!-- file -->
        <input
          ref="file"
          :accept="accept"
          :disabled="disabled"
          hidden
          type="file"
          @change="fileChange"
        />
        <div
          v-if="!file && !url"
          class="file__upload text-center full-width py-4"
          :class="[drag ? 'drag' : '']"
          @click="goAddFile"
          @dragenter="
            if (disabled) return
            overrideDefault($event)
            hoverDrag()
          "
          @dragleave="
            if (disabled) return
            overrideDefault($event)
            hoverDragEnd()
          "
          @dragover="
            if (disabled) return
            overrideDefault($event)
            hoverDrag()
          "
          @drop="
            if (disabled) return
            overrideDefault($event)
            hoverDragEnd()
            fileChange($event)
          "
        >
          <v-icon size="30">mdi-paperclip</v-icon>
          <div class="mt-2">{{ title }}</div>
        </div>
        <!-- end file -->

        <template
          v-if="progressFile && (!progressFile.isDone || progressFile.isError)"
        >
          <UploadItem :item="progressFile" @click:remove="onRemove()" />
        </template>
        <template v-else-if="url">
          <FileCard :file="fileView">
            <template #extra="">
              <base-button icon @click.stop="viewFile(fileView, type)">
                <v-icon> mdi-eye </v-icon>
              </base-button>
              <base-button icon type-action="delete" @click="onRemove(file)">
              </base-button>
            </template>
          </FileCard>
        </template>
      </div>
    </template>
  </FileViewContainer>
</template>
<script>
import FileCard from '@components/file/file-card.vue'
import FileViewContainer from '@components/file/file-view-container.vue'
import { convertLinkToBackEnd } from '@/src/utils'
import UploadItem from '@components/progress-upload/upload-item.vue'
import { mapGetters } from 'vuex'
export default {
  components: { FileViewContainer, FileCard, UploadItem },
  props: {
    disabled: Boolean,
    value: {
      required: false,
    },
    title: {
      required: true,
      type: String,
    },
    type: { type: String, default: 'image' },
    accept: { type: String, default: 'image/*' },
    urlUpload: { type: String, default: 'attach-feature-file' },
  },
  data: () => ({
    file: [],
    drag: false,
    url: '',
    idUpload: '',
  }),
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.file = null
          return
        }
        if (typeof value == 'string') {
          this.url = convertLinkToBackEnd(value)
          return
        }
        try {
          this.url = URL.createObjectURL(value)
        } catch (e) {
          console.error(e)
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      getProgressFileById: 'upload/getProgressFileById',
    }),
    progressFile() {
      return this.getProgressFileById(this.idUpload)
    },
    fileView() {
      return {
        name: this.getFileName(),
        file_type: this.type,
        type: this.type,
        path: this.url,
      }
    },
  },
  beforeDestroy() {
    if (this.idUpload && this.progressFile && !this.progressFile.isDone) {
      this.$store.dispatch('upload/cancelUpload', { id: this.idUpload })
      this.$store.commit('upload/removeQueueUpload', this.idUpload)
    }
  },
  methods: {
    getFileName() {
      if (this.file) return this.file.name
      if (!this.url) return ''

      return this.url.split(/(\\|\/)/g).pop()
    },
    // inputfile
    //drag event
    hoverDrag() {
      this.drag = true
    },
    hoverDragEnd() {
      this.drag = false
    },
    overrideDefault(e) {
      e.preventDefault()
      e.stopPropagation()
    },
    goAddFile() {
      this.$refs.file.click()
    },
    fileChange(e) {
      let files = e.dataTransfer ? e.dataTransfer.files : e.target.files

      this.file = files[0]
      // this.url = URL.createObjectURL(this.file)
      this.$refs.file.value = ''
      // this.$emit('input', this.file)

      let formData = new FormData()
      formData.append(this.type, this.file)

      this.$store
        .dispatch('upload/callUpload', {
          url: `${this.urlUpload}`,
          data: formData,
          name: this.file.name,
          cbWhenComplete: (res) => {
            if (!this.file) {
              return
            }
            this.$store.commit('upload/removeQueueUpload', this.idUpload)
            this.url = res.data.path
            this.$emit('input', this.url)
          },
        })
        .then((res) => {
          this.idUpload = res.id
        })
    },
    reset() {
      this.url = ''
      this.file = null
      this.$emit('input', '')
      this.idUpload = ''
    },
    onRemove() {
      this.reset()
    },
  },
}
</script>
<style scoped>
/* effect drag */
.remove {
  position: absolute;
  top: 0;
  right: 0;
  background: white;
}
.drag {
  border: 3px dashed var(--v-colorText-base);
}
.file__upload {
  background-color: #eceff1;
  border-radius: 6px;
  cursor: pointer;
}
.v-icon.mdi-paperclip {
  transform: rotate(45deg);
}
.ls_document {
  color: var(--v-colorText-base);
}
@media (max-width: 600px) {
  .file__upload {
    background-color: #eceff1;
    padding-left: 50px !important;
    padding-right: 50px !important;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>
